import React from 'react';
import { Link } from 'react-router-dom';

const BG_IMAGES = {
  About:     'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1800&auto=format&fit=crop&q=70',
  Services:  'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1800&auto=format&fit=crop&q=70',
  Portfolio: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=1800&auto=format&fit=crop&q=70',
  Contact:   'https://images.unsplash.com/photo-1497366412874-3415097a27e7?w=1800&auto=format&fit=crop&q=70',
};

const PageHero = ({ title, highlight, subtitle, breadcrumb }) => {
  const bg = BG_IMAGES[breadcrumb] || BG_IMAGES.About;
  return (
    <section className="page-hero">
      <div className="page-hero-bg" style={{ backgroundImage:`url('${bg}')` }} />
      <div className="page-hero-overlay" />
      <div className="container position-relative" style={{ zIndex:2 }}>
        <div style={{ fontFamily:'var(--font-body)', fontSize:'0.65rem', letterSpacing:'0.25em', textTransform:'uppercase', color:'var(--tan2)', marginBottom:'1rem' }}>
          <Link to="/" style={{ color:'var(--tan2)' }}>Home</Link>
          {breadcrumb && <> &nbsp;/&nbsp; <span style={{ color:'var(--tan)' }}>{breadcrumb}</span></>}
        </div>
        <h1 style={{ fontFamily:'var(--font-disp)', fontWeight:400, fontSize:'clamp(3rem,7vw,6.5rem)', lineHeight:0.95, color:'var(--cream2)', letterSpacing:'-0.02em', marginBottom:'1.2rem' }}>
          {title}<br/><em style={{ color:'var(--tan)' }}>{highlight}</em>
        </h1>
        {subtitle && <p style={{ color:'var(--muted)', fontSize:'0.9rem', lineHeight:1.85, maxWidth:520, fontWeight:300 }}>{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHero;
